import { createAction } from '@reduxjs/toolkit';
import { IBroadcastMessagesState } from '@store/broadcast-messages/types';

export class GetUsersCountReset {
  static get action() {
    return createAction('broadcastMessages/GET_USERS_COUNT_RESET');
  }

  static get reducer() {
    return (draft: IBroadcastMessagesState) => {
      draft.usersCount = null;

      return draft;
    };
  }
}
